// extracted by css-extract-rspack-plugin
export default {"container":"enP_e","qrCode":"GDQkA"};